import { request as umiRequest } from '@umijs/max';
import type { RequestOptions } from '@@/plugin-request/request';
import { BizAppConfig } from 'config/application.manifest';

type ScopedRequestOptions = RequestOptions;

export type ApiResponse<T> = {
  code: number | string;
  msg: string;
  data: T | null;
};

export const createRequest = (baseURL?: string): (<T = unknown>(url: string, options?: ScopedRequestOptions) => Promise<T>) => {
  const scopedBaseURL = baseURL ?? BizAppConfig.appApiUrl ?? '';
  return <T = unknown>(url: string, options?: ScopedRequestOptions) =>
    (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )<ApiResponse<T> | T>(url, {
      baseURL: scopedBaseURL,
      ...(options || {}),
    }).then(response => {
      if (options?.responseType === 'blob') {
        return response as T;
      }

      if (response && typeof response === 'object' && 'data' in response) {
        return response.data as T;
      }

      return response as T;
    });
};

export const createAppRequest = () => createRequest(BizAppConfig.appApiUrl);
export const createTenantManagementRequest = () => createRequest(BizAppConfig.appTenantManagementUrl);
